<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblEditSpecialTool</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>

      </div>
      <form [formGroup]="editSpecialToolForm" *ngIf="SpecialToolModel" (ngSubmit)="editSpecialTools()">
        <div class=" scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="row">
                <div class="col-md-6 af-form-group">
                  <label for="service" translate>lblBrand
                    <strong class="mlt6 required"> * </strong> </label>
                  <div class='lbl-info'>
                    <ng-select class="" formControlName="brand" placeholder="{{ 'lblSelectBrand' | translate }}">
                      <option disabled [ngValue]="null" translate>lblSelectCompany</option>
                      <ng-template ng-header-tmp>
                        <span class="mbold w-66px">Code</span>
                        <span class="mbold" translate>lblBrand</span>
                      </ng-template>

                      <ng-option *ngFor="let brand of brandList" [value]="brand.brandName">
                        <span class="w-66px">{{brand.brandCode}}</span>
                        <span class="mx-2 hide-ng-dropdown-panel">-</span>
                        <span>{{brand.brandName}}</span>
                      </ng-option>
                    </ng-select>
                  </div>
                </div>
                <div class="col-md-6 af-form-group">
                  <label for="service" translate>lblVehicalType</label>
                  <div class="lbl-info">
                    <ng-select formControlName="vehicletype" placeholder="{{ 'lblSelectVehical' | translate }}">
                      <ng-template ng-header-tmp>
                        <span class="mbold w-66px">Code</span>
                        <span class="mbold" translate>lblVehicalType</span>
                      </ng-template>

                      <ng-option *ngFor="let item of vehicleTypes" [value]="item.code">
                        <span class="w-66px">{{item.code}}</span>
                        <span class="mx-2 hide-ng-dropdown-panel">-</span>
                        <span>{{item.name}}</span>
                      </ng-option>
                    </ng-select>
                  </div>
                </div>

                <div class="col-md-6 af-form-group">
                  <label for="service" translate>lblPartNumber </label>
                  <div class='lbl-info'>
                    <input formControlName="partNumber" [(ngModel)]="SpecialToolModel.specialToolDetails.partNumber"
                      class="form-control mb-2" [ngClass]="{'is-invalid': cpf.partNumber.invalid}" maxlength="50">
                  </div>
                </div>

                <div class="col-md-6 af-form-group">
                  <label for="service" translate>lblPartGroup </label>
                  <div class='lbl-info'>
                    <input formControlName="partGroup" [(ngModel)]="SpecialToolModel.specialToolDetails.partGroup"
                      class="form-control mb-2" [ngClass]="{'is-invalid': cpf.partGroup.invalid}" maxlength="100">
                  </div>
                </div>

                <div class="col-md-6 af-form-group">
                  <label for="service" translate>lblSpecialToolType</label>
                  <div class="lbl-info">
                    <ng-select formControlName="specialToolTypeId" placeholder="{{ 'lblSelectSpecialToolType' | translate }}">
                      <ng-template ng-header-tmp>
                        <span class="mbold" translate>lblSpecialToolType</span>
                      </ng-template>
                      <ng-option *ngFor="let item of specialToolTypes" [value]="item.id">
                        <span>{{item.name}}</span>
                      </ng-option>
                    </ng-select>
                  </div>
                </div>
                <div class="col-md-6 af-form-group">
                  <label for="template-edit-image" translate>lblImage </label>
                  <div class="lbl-info">
                    <div class="border mb-3 p-1 d-inline-block">
                      <img af-image [data-code]="SpecialToolModel.specialToolDetails.partImage" [data-src]="image" id="UploadImage" alt="image does not found." class="carimg">
                    </div>
                    <div class="form-group">
                      <label class="btn btn-outline-primary d-inline-block" for="select-files"
                        translate>lblChangeLogo</label>
                      <input type="file" id="select-files" class="" hidden name="image" accept=".png, .jpg, .jpeg"
                        (change)="onChangeFileUpload($event.target.files)">
                    </div>
                  </div>
                </div>

                <div class="w-100"></div>

                <div class="w-100 px-0" *ngIf="t.controls">
                  <div class="col-md-6" *ngFor="let ticket of t.controls; let i = index">
                    <div [formGroup]="ticket">
                      <div class="af-form-group">
                        <label for="partDescription" translate>lblPartDescription<span> in
                            {{allLanguage[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class='lbl-info'>
                          <input formControlName="description" class="form-control mb-2" required maxlength="200"
                            [ngClass]="{'is-invalid': cpf.partDescription.invalid }">
                          <div *ngIf="cpf.partDescription.errors?.required" class="help-block mt-1 text-danger"
                            translate>
                            <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                            lblPartDescriptionRequired
                          </div>
                        </div>
                      </div>
                      <div class="af-form-group" style="display: none;">
                        <label for="languageId" translate>Language Id</label>
                        <div class='lbl-info'>
                          <input formControlName="languageId" class="form-control mb-2" [ngModel]="allLanguage[i].id"
                            required maxlength="30">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 af-form-group">
                  <div class="lbl-info">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input"
                        [(ngModel)]="SpecialToolModel.specialToolDetails.isActive" id="isActive"
                        formControlName="isActive">
                      <label class="custom-control-label" for="isActive" translate>lblActive</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="d-flex flex-sm-row flex-column justify-content-end">
            <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align"
              [disabled]="!editSpecialToolForm.valid" translate>lblSaveChanges</button>
            <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate>lblCancel</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
